(($, Drupal) => {
  Drupal.behaviors.results = {
    attach: function attach() {
      once('sidebarMobileToggle', '.sidebar-mobile-title').forEach(
        (el) => {
          const sidebar = document.getElementById('js-sidebar');
          el.addEventListener('click', () => {
            sidebar.classList.toggle('is-active');
          });
        },
      );

      once('filtersCollapse', '.collapsible').forEach(
        (el) => {
          el.addEventListener('click', function () {
            if (!window.matchMedia('(min-width: 1024px)').matches) {
              this.classList.toggle('active');
              const content = this.nextElementSibling;
              content.classList.toggle('active');
              if (content.style.maxHeight) {
                content.style.maxHeight = null;
              } else {
                content.style.maxHeight = `${content.scrollHeight}px`;
              }
            }
          });
        },
      );
    },
  };
})(jQuery, Drupal);
